/* eslint-disable radix */
/* eslint-disable prefer-template */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
// material
import {
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Paper,
  TableHead,
  Grid,
  Box,
  Modal,
  TextField,
  LinearProgress,
  InputAdornment,
  IconButton,
  Divider,
  MenuItem,
  Skeleton,
  Badge,
  Menu,
  Alert,
  CircularProgress,
  alpha,
} from '@mui/material';
// eslint-disable-next-line import/no-duplicates
import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  where,
  getCountFromServer,
  orderBy,
  startAfter,
  endBefore,
  limitToLast,
  updateDoc,
} from 'firebase/firestore';
import { PDFDownloadLink } from '@react-pdf/renderer';

// eslint-disable-next-line import/no-duplicates

import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { LoadingButton } from '@mui/lab';
import { httpsCallable } from 'firebase/functions';
import { styled } from '@mui/system';
import { db, functions } from '../../firebase.config';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
// mock
import USERLIST from '../../_mock/user';
import PdfDocument from '../../components/pdf/pdfdoc';
import Swipeable from '../crm/component/swiper';
import { Variables } from '../../context/VariableContext';
import PdfTicket from '../../components/pdf/Ticket/pdfTicket';
import CustomTag from '../../components/customTag';
import CustomButton from '../../components/CustomButton';
import LucideIcon from '../../components/LucideIcon';
// eslint-disable-next-line no-var
var QRCode = require('qrcode');

// ----------------------------------------------------------------------

const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 500,
  // maxHeight:200,
  bgcolor: 'white',
  border: '1px solid white',
  borderRadius: '7px',
  boxShadow: 0,
  p: 3,
};



// ----------------------------------------------------------------------

const ITEM_HEIGHT = 48;


export default function ShowParticipant() {

  const { eventID } = useParams();
  const { ticketId } = useParams();






  // take tickets from firebase

  const [billet, setBillet] = React.useState(null);
  const [commande, setCommande] = React.useState(null);
  const navigate = useNavigate();
  const [names, setName] = React.useState([]);
  const [queryContains, setQueryContains] = React.useState([]);

  const [reload, setReload] = React.useState(false);
  // ticket download
  const [info, setInfo] = React.useState();



  React.useEffect(() => {
    const fetchBilletAndCommande = async () => {
      if (!eventID || !ticketId) {
        console.warn('eventID ou ticketId manquant');
        return;
      }

      console.log('Chargement billet pour eventID:', eventID, 'ticketId:', ticketId);
      setLoading(true);
      try {
        const billetRef = doc(db, `evenement/${eventID}/billets`, ticketId);
        const billetSnap = await getDoc(billetRef);

        if (!billetSnap.exists()) {
          console.warn('Billet introuvable');
          setLoading(false);
          return;
        }

        const billetData = billetSnap.data();
        setBillet(billetSnap);

        const commandeRef = doc(db, `evenement/${eventID}/commandes`, billetData.refCommande);
        const commandeSnap = await getDoc(commandeRef);

        if (commandeSnap.exists()) {
          setCommande(commandeSnap.data());
        } else {
          console.warn('Commande liée non trouvée');
        }
      } catch (error) {
        console.error('Erreur lors du chargement du billet ou de la commande:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBilletAndCommande();
  }, [eventID, ticketId]);


  // loading
  const [loading, setLoading] = React.useState(false);

  // handle modification
  const [modif, setModif] = React.useState(false);

  const [curIndex, setIndex] = React.useState();


  const handleModif = (index) => {
    if (modif) {
      setModif(false);
    } else {
      setIndex(index);
      console.log(curIndex);
      setModif(true);
    }
  };
  // convert timestamp

  const handleTimestamp = (e) => {
    const date = e.toDate();
    const tmp = date.toJSON().split('.');
    return tmp[0];
  };


  // filtre


  // more acceuil participant
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // more acceuil participant
  const [anchorElDetail, setAnchorElDetail] = React.useState(null);
  const openMenuDetail = Boolean(anchorElDetail);
  const handleClickMenuDetail = (event) => {
    setAnchorElDetail(event.currentTarget);
  };
  const handleCloseMenuDetail = () => {
    setAnchorElDetail(null);
  };

  // Modal download liste participants
  const [openDownloadModal, setOpenDownloadModal] = React.useState(false);
  const handleOpenDownloadModal = () => setOpenDownloadModal(true);
  const handleCloseDownloadModal = () => setOpenDownloadModal(false);

  // Modal download Ticket
  const [openTicketModal, setOpenTicketModal] = React.useState(false);
  const handleOpenTicketModal = () => setOpenTicketModal(true);
  const handleCloseTicketModal = () => setOpenTicketModal(false);
  const [qrcode, setQr] = useState('');

  const downloadTicket = async () => {
    try {
      const docSnap = await getDoc(doc(db, `evenement`, `${eventID}`));
      if (docSnap.exists()) {
        console.log(docSnap.data());
        console.log(billet);
        const orgSnap = await getDoc(doc(db, `organisations`, `${docSnap.data().orgId}`));
        console.log(orgSnap.data());
        const tmp = {
          billet: billet.data(),
          event: docSnap.data(),
          commande,
          org: orgSnap.data(),
        };
        setInfo(tmp);
      }

      QRCode.toDataURL(
        billet.data().numero,
        {
          width: 130,
          margin: 1,
          errorCorrectionLevel: 'H',
          color: {
            dark: '#000000',
            light: '#ffffff',
          },
        },
        (err, url) => {
          if (err) return console.log('erreur : ', err);
          setQr(url);
        }
      );
    } catch (error) {
      console.log(error);
    }
    handleCloseMenuDetail();
    handleOpenDownloadModal();
    // handleCloseDownloadModal();
  };


  // Modal Remboursement
  const [openRembModal, setOpenRembModal] = React.useState(false);
  const [loadingRemb, setLoadingRemb] = React.useState(false);
  const handleOpenRembModal = () => setOpenRembModal(true);
  const handleCloseRembModal = () => setOpenRembModal(false);

  const handleRenboursement = async () => {
    handleCloseMenuDetail();
    handleOpenRembModal();
  };
  const handleRenboursementPin = async () => {
    setLoadingRemb(true);
    handleCloseMenuDetail();
    handleOpenRembModal();
    try {
      // envoye du token de validation
      const addMessage = httpsCallable(functions, 'email_token');
      const result = await addMessage({ email: commande?.email, event: eventID });
    } catch (error) {
      //
    }
    setLoadingRemb(false);
    handleOpenRembModal();
    handleCloseRembModal();
    // ouverture du modal de validation du token envoyé par mail
    handleOpenTokenModal();
  };
  const handleRenboursementConfirm = async () => {
    setLoadingRemb(true);
    handleCloseMenuDetail();
    handleOpenRembModal();
    try {
      // envoye du token de validation
      const addMessage = httpsCallable(functions, 'email_token');
      const result = await addMessage({ email: commande?.email, event: eventID });
    } catch (error) {
      //
    }
    setLoadingRemb(false);
    handleOpenRembModal();
    handleCloseRembModal();
    // ouverture du modal de validation du token envoyé par mail
    handleOpenTokenModal();
  };

  // Modal token validation
  const [pin, setPin] = React.useState(['', '', '', '', '', '', '']);
  const handlePinChange = (index, value) => {
    const newPin = [...pin];
    if (/^\d$/.test(value)) {
      newPin[index] = value;
    }

    if (newPin[index] !== undefined && newPin[index] !== null) {
      newPin[index] = value.charAt(value.length - 1);
    }
    if (index > 0 && value === '') {
      // If a digit is deleted, move focus to the previous input
      document.getElementById(`pin-input-${index - 1}`).focus();
    } else if (index < 6 && value !== '') {
      // Move focus to the next input
      document.getElementById(`pin-input-${index + 1}`).focus();
    }
    setPin(newPin);
    // Check if all 7 digits are entered
    if (newPin.every((digit) => digit !== '')) {
      setToken(newPin.join(''));
      verifiedToken(newPin.join(''));
    }
  };

  //------------------------------------------------------
  const [openTokenModal, setOpenTokenModal] = React.useState(false);
  const [token, setToken] = React.useState('');
  const [percent, setPercent] = React.useState();
  const [billetRembourser, setBilletRembourser] = React.useState();
  const [montantRembourser, setMontantRembourser] = React.useState();
  const [tokenError, setTokenError] = React.useState(false);
  const handleOpenTokenModal = () => setOpenTokenModal(true);
  const handleCloseTokenModal = () => setOpenTokenModal(false);

  const handleChangePourcentage = (e) => {
    console.log(e.target.value)
    if (e.target.value !== '' && e.target.value > 0) {
      setPercent(e.target.value)
    }
  };

  const verifiedToken = async (e) => {
    setLoadingRemb(true);
    try {
      const docSnap = await getDoc(doc(db, `actionToken`, `${eventID}-${e}`));
      if (docSnap.exists()) {
        if (docSnap.data().actif) {
          await updateDoc(doc(db, `actionToken`, `${eventID}-${e}`), {
            actif: false,
          });
          // await getDoc(doc(db, `Remboursements`, `${docSnap.data().orgId}`));
          // Lancer le processus de Remboursement
          setTokenError(false);
          handleCloseTokenModal();
          handleOpenRembModal();
        } else {
          setTokenError(true);
          setPin(['', '', '', '', '', '', '']);
        }
      } else {
        setTokenError(true);
        setPin(['', '', '', '', '', '', '']);
      }
    } catch (error) {
      console.error(error);
    }
    setToken('');
    setLoadingRemb(false);
    // handleCloseMenuDetail();

    // handleCloseDownloadModal();
  };

  const makeRenboursement = async () => {
    setLoadingRemb(true);
    try {
      const docSnap = await getDoc(doc(db, `actionToken`, `${eventID}-${token}`));
      if (docSnap.exists()) {
        if (docSnap.data().actif) {
          await updateDoc(doc(db, `actionToken`, `${eventID}-${token}`), {
            actif: false,
          });
          // await getDoc(doc(db, `Remboursements`, `${docSnap.data().orgId}`));
        }
      }
    } catch (error) {
      console.log(error);
    }
    setToken('');
    handleCloseMenuDetail();
    handleCloseTokenModal();
    // handleCloseDownloadModal();
  };

  return (
    <Page title="Gestion Participants">
      {loading && <LinearProgress />}

      <Container sx={{ marginTop: { xs: 3 } }}>
        {commande != null && billet != null && (
          <>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'start' }}>

              <CustomButton type='back' buttonText='Retour' onClick={() => navigate(-1, { replace: true })} />
            </Box>

            <Stack direction="row" alignItems="center" justifyContent="space-between" marginY={2}>

              <Typography variant="h6" gutterBottom>
                Billet N° {billet.data().numero}
              </Typography>


              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={openMenuDetail ? 'long-menu' : undefined}
                aria-expanded={openMenuDetail ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClickMenuDetail}
                sx={{ bgcolor: '#f2f2f2' }}
              >
                <LucideIcon name='EllipsisVertical' />

              </IconButton>
              <Menu
                id="long-menu"
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorElDetail}
                open={openMenuDetail}
                onClose={handleCloseMenuDetail}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '30ch',
                  },
                }}
              >
                <MenuItem key="1" onClick={() => downloadTicket()}>
                  <LucideIcon name='Download' />
                  Telecharger
                </MenuItem>
                { /* <MenuItem key="1" onClick={() => handleRenboursement()}>
                  <LucideIcon name='RotateCcw' />
                  Rembourser
                </MenuItem> */ }
              </Menu>
              <Modal
                open={openDownloadModal}
                onClose={handleCloseDownloadModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ borderRadius: '7px' }}
              >
                <Box sx={styleModal}>
                  <Typography variant="body2">
                    Cliquez{' '}
                    <PDFDownloadLink
                      document={<PdfTicket info={info} qr={qrcode} />}
                      fileName={`${info ? info.billet.refCommande : 'undefined'}.pdf`}
                    >
                      {({ blob, url, loading, error }) => {
                        console.log('erreur : ', error);
                        return loading ? 'Genration du ticket......' : 'ici';
                      }}
                    </PDFDownloadLink>{' '}
                    pour techarger le ticket
                  </Typography>
                </Box>
              </Modal>
              {/** Modal Remboursement */}
              <Modal
                open={openRembModal}
                onClose={handleCloseRembModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ borderRadius: '7px' }}
              >
                <Box sx={styleModal}>
                  {loadingRemb ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      <Stack direction="row">
                        <Typography variant="h6">Remboursement</Typography>
                      </Stack>

                      <Box sx={{ p: 2 }} dir="ltr">
                        {commande?.totalBillet > 1 && (
                          <Alert severity="info">
                            Ce ticket fait partir de la meme commandes avec {commande?.totalBillet - 1} autre(s) ticket(s).
                          </Alert>
                        )}
                      </Box>
                      <Box sx={{ p: 2 }} dir="ltr">
                        <TextField
                          label="Pourcentage à rembouser"
                          required
                          fullWidth
                          helperText="100% du prix du billet dera remboursé."
                          type="number"
                          value={percent}
                          onChange={handleChangePourcentage}
                        />
                      </Box>

                      <Box
                        sx={{
                          height: '100%',
                          borderRadius: '7px',
                          padding: 2,
                          border: '2px solid transparent',
                          bgcolor: '#f2f2f2',
                          borderColor: '#f2f2f2',
                        }}
                      >
                        <Typography>Recapitulatif</Typography>
                        <Typography variant="caption">Nombre de billets à rembourser :</Typography>
                        <Typography variant="body2">1</Typography>
                        <Typography variant="caption">Montant total à rembourser :</Typography>
                        <Typography variant="body2">1000 CFA</Typography>
                      </Box>

                      <Grid container spacing={2} justifyContent="end" paddingTop={5}>
                        <Grid item>
                          <Button
                            variant="outlined"
                            sx={{
                              textTransform: 'initial',
                              border: '2px solid transparent',
                              color: 'black',
                              backgroundColor: 'white',
                              borderRadius: '7px',
                              borderColor: 'black',
                              '&:hover': {
                                backgroundColor: 'black',
                                color: 'white',
                                borderColor: 'black',
                              },
                            }}
                            onClick={handleCloseRembModal}
                          >
                            Annuler
                          </Button>
                        </Grid>
                        <Grid item>
                          <LoadingButton
                            variant="contained"
                            sx={{
                              textTransform: 'initial',
                              border: '2px solid transparent',
                              Color: 'white',
                              backgroundColor: 'red',
                              borderRadius: '7px',
                              '&:hover': {
                                backgroundColor: 'white',
                                color: 'red',
                                borderColor: 'red',
                              },
                            }}
                            onClick={handleRenboursementPin}
                          >
                            Confirmer le remboursement
                          </LoadingButton>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Box>
              </Modal>
              {/** Fin Modal remboursement */}
              {/** Modal validation de token */}
              <Modal
                open={openTokenModal}
                onClose={handleCloseTokenModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ borderRadius: '7px' }}
              >
                <Box sx={styleModal}>
                  <Typography variant="h6">Token de validation</Typography>
                  <Box sx={{ p: 2 }} dir="ltr">
                    <Typography variant="body2">
                      Veuillez entrez le code de validation qui vous a été envoyé par mail.
                    </Typography>
                  </Box>
                  {tokenError && !loadingRemb && (
                    <Box sx={{ p: 2 }} dir="ltr">
                      <Alert severity="error">Le code saisi est incorrecte, veuillez saisir le bon code.</Alert>
                    </Box>
                  )}
                  <Box sx={{ p: 2 }} dir="ltr">
                    {loadingRemb ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CircularProgress />
                      </Box>
                    ) : (
                      <Stack direction="row" spacing={2} justifyContent="center">
                        {pin.map((digit, index) => (
                          <Box key={index}>
                            <TextField
                              key={index}
                              id={`pin-input-${index}`}
                              type="number"
                              variant="outlined"
                              size="medium"
                              maxLength="1"
                              value={digit}
                              onChange={(e) => handlePinChange(index, e.target.value)}
                              sx={{ width: '40px' }}
                            />
                          </Box>
                        ))}
                      </Stack>
                    )}
                  </Box>
                </Box>
              </Modal>
              {/** Fin Modal validation de token */}
            </Stack>
            <Grid container justifyContent="space-between" spacing={5}>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    height: '100%',
                    borderRadius: '7px',
                    padding: 3,
                    border: '2px solid transparent',
                    cursor: 'pointer',
                    borderColor: '#f2f2f2',
                  }}
                >
                  <Stack spacing={2} direction={'row'}><LucideIcon name='Ticket' /> <Typography variant='subtitle1' textAlign="Start">
                    Billet N° {billet.data().numero}
                  </Typography></Stack>


                  <Stack spacing={2} paddingTop={2}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Nom du ticket :
                      </Typography>
                      <Typography variant="body2">{billet.data().nom}</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Prix :
                      </Typography>
                      <Typography variant="body2">
                        {billet?.data().price === 0 ? 'Gratuit' : billet?.data().price + ' CFA'}{' '}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Scanné :
                      </Typography>
                      <Typography variant="body2">
                        {billet?.data().scanner === 1 ? 'oui' : 'non'}{' '}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Status :
                      </Typography>
                      <Typography variant="body2">
                        {billet?.data().status === 1 ? 'actif' : 'desactivé'}{' '}
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    height: '100%',
                    borderRadius: '7px',
                    padding: 3,
                    border: '2px solid transparent',
                    cursor: 'pointer',
                    borderColor: '#f2f2f2',
                  }}
                >
                  <Stack spacing={2} direction={'row'}><LucideIcon name='ShoppingBasket' /> <Typography variant='subtitle1' textAlign="Start">
                    Commande N° {billet.data().refCommande}
                  </Typography></Stack>
                  <Stack spacing={2} paddingTop={2}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Nombre de billets :
                      </Typography>
                      <Typography variant="body2">{commande.totalBillet}</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Date de la commande :
                      </Typography>
                      <Typography variant="body2">
                        {format(new Date(handleTimestamp(commande.date)), 'EEE dd MMM yyyy HH:mm', {
                          locale: fr,
                        }).toString()}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Montant payé :
                      </Typography>
                      <Typography variant="body2"> {commande.totalPrice} CFA</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Reduction :
                      </Typography>
                      <Typography variant="body2">
                        {billet.data().reduction ? billet.data().reduction : '-'}{' '}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Moyen de paiement :
                      </Typography>
                      <Typography variant="body2">
                        {billet.data().scanner === 1 ? 'oui' : 'non'}{' '}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Origine :
                      </Typography>
                      <Typography variant="body2">
                        {commande.origine === 0
                          ? 'Ajout manuel'
                          : commande.origine === 1
                            ? 'Web / app'
                            : commande.origine === 2
                              ? 'Guichet'
                              : null}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Statut :
                      </Typography>
                      <Typography variant="body2">
                        {' '}
                        {commande.status === 0
                          ? 'Reservé'
                          : commande.status === 1
                            ? 'Payé'
                            : null}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        N° facture :
                      </Typography>
                      <Typography variant="body2">
                        {commande.idFacture}{' '}
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    height: '100%',
                    borderRadius: '7px',
                    padding: 3,
                    border: '2px solid transparent',
                    cursor: 'pointer',
                    borderColor: '#f2f2f2',
                  }}
                >
                  <Stack spacing={2} direction={'row'}><LucideIcon name='UserRound' /> <Typography variant='subtitle1' textAlign="Start">
                    Information sur l'acheteur
                  </Typography></Stack>
                  <Stack spacing={2} paddingTop={2}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Nom / prenoms :
                      </Typography>
                      <Typography variant="body2">{commande.nom}</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Tel :
                      </Typography>
                      <Typography variant="body2">
                        {commande.tel !== '' ? commande.tel : '-'}{' '}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle2">
                        Email :
                      </Typography>
                      <Typography variant="body2">{commande.email}</Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </>
        )}
      </Container>

    </Page>
  );
}
